'use client';
import { SeriesTitleProps } from '@repo/ui/src/primitives/SeriesTitleAndText';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { BackgroundStyleEnum } from '@repo/ui/src/enums/shared-enums';
import { ImageProps } from '../../types';
import Container from '@repo/ui/src/components/Container';
import Section from '@repo/ui/src/components/Section';

interface Props {
  columns: Array<SeriesTitleProps | ImageProps>;
  background?: BackgroundStyleEnum;
}

const isDarkBackground = (bg?: BackgroundStyleEnum) =>
  bg === BackgroundStyleEnum.Black ||
  bg === BackgroundStyleEnum.DarkGray ||
  bg === BackgroundStyleEnum.TextureDark ||
  bg === BackgroundStyleEnum.ButcherPaper;


const FlexContainer = ({ columns, background }: Props) => {
  if (!columns) return null;

  const dark = isDarkBackground(background);

  return (
    <Section
      as="section"
      white={!background || background === BackgroundStyleEnum.White}
      dark={
        background === BackgroundStyleEnum.TextureDark ||
        background === BackgroundStyleEnum.ButcherPaper
      }
      black={background === BackgroundStyleEnum.Black}
      darkGray={background === BackgroundStyleEnum.DarkGray}
      texture={
        background === BackgroundStyleEnum.TextureLight ||
        background === BackgroundStyleEnum.TextureDark
      }
      butcherPaper={background === BackgroundStyleEnum.ButcherPaper}
    >
      <Container
        maxWidth="wide"
        className="flex flex-col justify-center gap-6 py-4 sm:flex-row sm:py-12 sm:gap-12"
      >
        {columns.map((props, i) => (
          <div key={props?._meta?.deliveryId ?? i} data-testid={props?._meta?.deliveryId}>
            {!(props as ImageProps)?.image && (
              <ToutContent
                {...props}
                buttons={'button' in props ? props.button : []}
                divider={'showDivider' in props ? props.showDivider : undefined}
                dark={dark || ('darkMode' in props ? props.darkMode : undefined)}
              />
            )}
          </div>
        ))}
      </Container>
    </Section>
  );
};

export default FlexContainer;
